import React from 'react';
import { sortBy } from 'lodash';
import { connect } from 'react-redux';
import { hasPermission } from 'selectors';
import * as actions from '../../actions/shared/index/filter';
import Filter from '../shared/index/filters';

const PeopleFilters = props => (
  <Filter.Toolbar>
    {props.type === 'user' && props.noActiveGroup && (
      <Filter.MultiSelect
        data={props.groupsMetaData}
        label={{ plural: 'Groups', singular: 'Group' }}
        sort={{ key: 'name', descending: false }}
        selected={props.selectedGroups}
        applyCallback={selected => props.updateGroups(selected)}
      />
    )}
    <Filter.DatePicker
      applyCallback={dateData => props.updateDate(dateData)}
      longLabel="Date Created"
      startDate={props.selectedDate ? props.selectedDate.start : null}
      endDate={props.selectedDate ? props.selectedDate.end : null}
    />
    {props.type === 'user' && (
      <Filter.Select
        name="roleFilter"
        label="Role"
        selectedValue={props.selectedRole}
        selectCallback={id => props.updateRole(id)}
      >
        {sortBy(props.rolesMetaData, 'name').map(({ id, name }) => (
          <option key={id} value={id}>
            {name}
          </option>
        ))}
      </Filter.Select>
    )}
    {props.canEditAllGroups && (
      <Filter.Select
        name="managedByFilter"
        label="Managed By"
        selectedValue={props.selectedManager}
        selectCallback={manager => props.updateManager(manager)}
      >
        {props.managersMetadata.map(({ id, name }) => (
          <option key={id} value={id}>
            {name}
          </option>
        ))}
      </Filter.Select>
    )}
    <Filter.Search
      value={props.selectedQuery}
      submitCallback={query => props.updateQuery(query)}
    />
  </Filter.Toolbar>
);

const mapStateToProps = state => ({
  selectedType: state.filter.type,
  selectedQuery: state.filter.query,
  selectedGroups: state.filter.groups.map(g => window.parseInt(g)),
  selectedDate: state.filter.date,
  selectedRole: state.filter.role,
  selectedManager: state.filter.manager,
  rolesMetaData: state.data.meta.roles,
  groupsMetaData: state.data.meta.groups,
  managersMetadata: state.data.meta.managers,
  type: state.data.contentType,
  canEditAllGroups: hasPermission(state, 'editAllGroups'),
  noActiveGroup: !state.filter.activeGroup,
});

const mapDispatchToProps = dispatch => ({
  updateType(type) {
    dispatch(actions.filterUpdateType(type));
  },
  updateGroups(groups) {
    dispatch(actions.filterUpdateGroups(groups));
  },
  updateQuery(query) {
    dispatch(actions.filterUpdateQuery(query));
  },
  updateDate(date) {
    dispatch(actions.filterUpdateDate(date));
  },
  updateRole(role) {
    dispatch(actions.filterUpdateRole(role));
  },
  updateManager(manager) {
    dispatch(actions.filterUpdateManager(manager));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PeopleFilters);
